/**
 * 语言工具函数
 * 多语言站点使用构建时注入的语言
 */

const LANGUAGE_KEY = 'language'

// 构建时注入的语言（由构建环境变量 VUE_APP_LANG 提供，缺省 en）
// 用法：先设 $env:VUE_APP_LANG='fr' 再执行 npm run build
const ENV_LANG = process.env.VUE_APP_LANG || 'en'

/**
 * 获取当前语言
 * 优先使用构建时注入的语言（每个站点固定语言）
 * @returns {string} 语言代码
 */
export function getLanguage() {
  // 返回构建时注入的语言
  return ENV_LANG
}

/**
 * 设置语言（保留，仅用于兼容）
 * @param {string} lang 语言代码
 */
export function setLanguage(lang) {
  // 不再需要 localStorage 存储
}

/**
 * 移除语言设置
 */
export function removeLanguage() {
  // 不再需要
}

/**
 * 获取构建时的语言
 * @returns {string}
 */
export function getEnvLang() {
  return ENV_LANG
}
